<div class="desktop-search-container">
  @if (size !== 'phone' || (size === 'phone' && !hasIconOnlyWithOverlayMobileTemplate)) {
  <ng-container *ngTemplateOutlet="searchFieldOnPageTemplate"></ng-container>
  } @if (size === 'phone' && hasIconOnlyWithOverlayMobileTemplate) {
  <ng-container class="mobile-search-container">
    <button type="button" mat-icon-button (click)="triggerSearchOverlay()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
      <mat-icon>search</mat-icon>
    </button>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="overlayIsOpen"
      [cdkConnectedOverlayPanelClass]="'mobile-search-overlay'"
      [cdkConnectedOverlayScrollStrategy]="scrollStrategy">
      <div class="mobile-search-container__search-wrapper">
        <ng-container *ngTemplateOutlet="iconOnlyWithOverlayTemplate"></ng-container>
      </div>
    </ng-template>
  </ng-container>
  }
  <ng-template #searchFieldOnPageTemplate>
    <form class="search-input-form">
      <mat-form-field appearance="fill" class="form-field">
        <mat-icon class="search-field__icon" matPrefix>search</mat-icon>
        <input
          matInput
          #searchFieldInput
          (keydown.enter)="onSubmit($event)"
          [(ngModel)]="searchTerm"
          [placeholder]="placeholderText ?? placeholderDefaultText"
          [formControl]="searchField"
          [matAutocomplete]="auto" />
        @if (searchField.value) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearInputField()">
          <mat-icon class="search-field__icon">close</mat-icon>
        </button>
        }
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSubmit()">
          @if (!searchField.value) { @for (entry of searchHistory; track identifyOption($index, entry)) {
          <mat-option [value]="entry">
            @if (asYouTypeResultWithIcon) {
            <mat-icon class="search-result-icon" matPrefix>history</mat-icon>
            }
            <span [innerHTML]="entry"></span>
          </mat-option>
          } } @for (option of options; track identifyOption($index, option)) {
          <mat-option [value]="option">
            @if (asYouTypeResultWithIcon) {
            <mat-icon class="search-result-icon" matPrefix>search</mat-icon>
            }
            <span [innerHTML]="option | autocompleteHighlightPipe : searchField.value"></span>
          </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </ng-template>
  <ng-template #iconOnlyWithOverlayTemplate>
    <div class="search-field">
      <button matPrefix mat-icon-button aria-label="Back" class="search-field__icon" (click)="triggerSearchOverlay()">
        <mat-icon class="search-field__icon">arrow_left_alt</mat-icon>
      </button>
      <form class="search-input-form">
        <mat-form-field appearance="fill" class="form-field">
          <input
            matInput
            #searchFieldInputIconOnly
            type="search"
            (keydown.enter)="onSubmit($event)"
            [(ngModel)]="searchTerm"
            [placeholder]="placeholderText ?? placeholderDefaultText"
            [formControl]="searchField" />
          @if (searchField.value) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="clearInputField()">
            <mat-icon class="search-field__icon">close</mat-icon>
          </button>
          }
        </mat-form-field>
      </form>
    </div>
    <div class="autocomplete-list">
      @if (!searchField.value) { @for (entry of searchHistory; track identifyOption($index, entry)) {
      <a (click)="onSelectMobileAutocomplete(entry)" class="autocomplete-list__item">
        @if (asYouTypeResultWithIcon) {
        <mat-icon class="search-result-icon" matPrefix>history</mat-icon>
        }
        <span class="item-text" [innerHTML]="entry"></span>
      </a>
      } } @for (option of options; track identifyOption($index, option)) {
      <a (click)="onSelectMobileAutocomplete(option)" class="autocomplete-list__item">
        @if (asYouTypeResultWithIcon) {
        <mat-icon class="search-result-icon" matPrefix>search</mat-icon>
        }
        <span class="item-text" [innerHTML]="option | autocompleteHighlightPipe : searchField.value"></span>
      </a>
      }
    </div>
  </ng-template>
</div>
